import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "small striped toggle no-underline" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, " Local "),
    /*#__PURE__*/_createElementVNode("th", null, " First Name "),
    /*#__PURE__*/_createElementVNode("th", null, " Last Name "),
    /*#__PURE__*/_createElementVNode("th", null, " Middle Name "),
    /*#__PURE__*/_createElementVNode("th", null, " Title "),
    /*#__PURE__*/_createElementVNode("th", null, " Email Address "),
    /*#__PURE__*/_createElementVNode("th", null, " Phone "),
    /*#__PURE__*/_createElementVNode("th", null, " Type "),
    /*#__PURE__*/_createElementVNode("th", null, " Account actions ")
  ])
], -1)
const _hoisted_3 = { class: "col-md-1" }
const _hoisted_4 = { class: "col-md-1" }
const _hoisted_5 = { class: "col-md-1" }
const _hoisted_6 = { class: "col-md-1" }
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = { class: "col-md-1" }
const _hoisted_10 = { class: "col-md-1" }
const _hoisted_11 = { class: "col-md-1" }
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Send PIN"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, " / ", -1)
const _hoisted_16 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Reject Request"
}
const _hoisted_17 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locals, (local) => {
        return (_openBlock(), _createElementBlock("tr", {
          class: "large",
          key: local.UILocalRequestID
        }, [
          _createElementVNode("td", _hoisted_3, _toDisplayString(local.OrgName), 1),
          _createElementVNode("td", _hoisted_4, _toDisplayString(local.FirstName), 1),
          _createElementVNode("td", _hoisted_5, _toDisplayString(local.LastName), 1),
          _createElementVNode("td", _hoisted_6, _toDisplayString(local.MiddleName), 1),
          _createElementVNode("td", _hoisted_7, _toDisplayString(local.Title), 1),
          _createElementVNode("td", _hoisted_8, _toDisplayString(local.Email), 1),
          _createElementVNode("td", _hoisted_9, _toDisplayString(local.Phone), 1),
          _createElementVNode("td", _hoisted_10, _toDisplayString(local.Type), 1),
          _createElementVNode("td", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("i", {
                  class: "plan-modal iatse-icon-lock-check",
                  onClick: ($event: any) => (_ctx.sendPin(local.UILocalRequestID))
                }, null, 8, _hoisted_14)
              ]),
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, [
                _createElementVNode("i", {
                  class: "plan-modal iatse-icon-lock",
                  onClick: ($event: any) => (_ctx.rejectRequest(local.UILocalRequestID))
                }, null, 8, _hoisted_17)
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}